console.log("working");
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const announcements = document.querySelectorAll(".announcement");
    console.log("ann", announcements);

    let currentAnnouncementIndex = 0;
    let timer;

    function displayNextAnnouncement() {
      if (announcements) {
        announcements[currentAnnouncementIndex]?.classList.remove("active");
      }

      currentAnnouncementIndex =
        (currentAnnouncementIndex + 1) % announcements.length;

      if (announcements) {
        announcements[currentAnnouncementIndex]?.classList.add("active");
      }

      timer = setTimeout(displayNextAnnouncement, 5000);
    }
    timer = setTimeout(displayNextAnnouncement, 5000);
  });
})();
